export function sessionQuestionReplyFailedMessage() {
  return "Your answer could not be sent. Check the connection and try again."
}

export function sessionPermissionRespondFailedMessage() {
  return "Permission response could not be sent. Check the connection and try again."
}
